import React from 'react';
import { Alert, Badge, Button } from 'react-bootstrap';
import { FaShieldAlt, FaCalendarAlt } from 'react-icons/fa';

const CurrentPlanAlert = ({ subscription, loading, onCancelSubscription }) => {
  return (
    <Alert variant="light" className="mb-4 border shadow-sm">
      <div className="d-flex justify-content-between align-items-center flex-wrap">
        <div className="d-flex align-items-center">
          <FaShieldAlt className="text-primary me-2" />
          <span className="fw-bold">Current Plan:</span>
          <Badge 
            bg={subscription?.current_plan?.toLowerCase() === 'free' ? 'secondary' : 'primary'} 
            className="ms-2 px-3 py-2"
          >
            {subscription?.current_plan || 'No Active Plan'}
          </Badge>
          {subscription?.current_plan?.toLowerCase() === 'free' && (
            <small className="text-muted ms-2">
              (Upgrade available)
            </small>
          )}
        </div>
        {subscription?.subscription_status === 'active' && 
         subscription?.current_plan?.toLowerCase() !== 'free' &&
         subscription?.current_plan?.toLowerCase() !== 'none' && (
          <Button
            variant="danger"
            size="sm"
            onClick={onCancelSubscription}
            disabled={loading}
          >
            <FaCalendarAlt className="me-1" />
            Cancel Subscription
          </Button>
        )}
        {subscription?.subscription_status === 'cancelled' && (
          <Badge bg="danger" className="px-3 py-2">
            Cancelled
          </Badge>
        )}
      </div>
    </Alert>
  );
};

export default CurrentPlanAlert;